import classnames from "classnames";
import { useState, useRef } from "react";
import useOnClickOutside from "utils/useOnClickOutside";
import FormField, { STYLE } from "components/FormField";
import styles from "./Dropdown.module.scss";

export const SIZE = {
  MIDDLE: "middle",
};

export const Dropdown = ({
  defaultValue,
  list,
  label,
  className,
  icon,
  value,
  setValue,
  keyValue,
  withInput,
  size,
  error,
  placeholderText,
  handleClick,
}) => {
  const ref = useRef([]);
  const containerRef = useRef();
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useOnClickOutside(containerRef, () => setIsOpen(false));

  return (
    <div className={classnames(styles.group, className)}>
      <label className={styles.label}>{label}</label>

      <div ref={wrapperRef} className={styles.container}>
        <div
          className={classnames(styles.wrapper, {
            [styles.isOpen]: isOpen && list.length,
          })}
          onClick={() => setIsOpen(!isOpen)}
        >
          {withInput ? (
            <>
              {icon}
              <FormField
                labelText=""
                value={value[keyValue]?.title}
                style={STYLE.LIGHT}
                className={styles.input}
                onChange={(e) =>
                  setValue({
                    ...value,
                    [keyValue]: {
                      title: e.target.value,
                      value: value[keyValue]?.value,
                      photoUrl: value[keyValue]?.photoUrl,
                    },
                  })
                }
                error={error}
                errorMessage={error?.message}
                placeholderText={placeholderText}
              />
            </>
          ) : (
            <div className={classnames(styles.heading, { [styles[size]]: size })}>
              {icon}
              {keyValue
                ? value[keyValue]?.title
                : value.title === ""
                ? defaultValue?.title
                : value.title}
            </div>
          )}
        </div>
        <ul
          ref={containerRef}
          className={classnames(styles.list, isOpen && list.length ? styles.show : "")}
        >
          {list?.map((item, index) => {
            return (
              <li
                ref={(element) => {
                  ref.current[index] = element;
                }}
                key={index}
                data-value={item.value}
                onClick={(e) => {
                  setIsOpen(!isOpen);
                  keyValue ? setValue({ ...value, [keyValue]: item }) : setValue(item);
                  handleClick?.(item);
                }}
                className={styles.item}
              >
                {item?.title}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
